export default { 
 
    action_id_para_imprimir ( context , valor ) { 
                       context.commit('mutation_id_para_imprimir',valor)  
                      
}  

}